export const convertToHumanReadableSize = (sizeInBytes) => {
  // We deliberately use the modern decimal approach according to IEC standard
  if (sizeInBytes < 1000) {
    return `${sizeInBytes} B`;
  }
  const sizeInKilobytes = sizeInBytes / 1000;
  if (sizeInKilobytes < 1000) {
    return `${Math.round(sizeInKilobytes)} kB`;
  }
  const sizeInMegabytes = sizeInKilobytes / 1000;
  return `${sizeInMegabytes.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} MB`;
};

export default convertToHumanReadableSize;
